// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FI9K","col":"styles_col__31pYh","actions":"styles_actions__xV9Xh","conflict":"styles_conflict__YjwQo"};